import { useAllWorklistContext } from 'views/pages/Worklist/AllWorklist/contexts/AllWorklistContext.ts';
import {
  usePartnerShortQuery,
  useProvidersShortQuery,
  useUpdateWorklistTablePreferencesMutation,
  useWorklistTablePreferencesQuery,
} from 'common/cache';
import { useAllWorklistStore } from 'store';
import { SelectChangeEvent } from '@mui/material';
import { paths } from '@types';

export const useFilters = () => {
  const {
    handleFilterChange,
    filters,
    completedFilters,
    handleCompletedFilterChange,
  } = useAllWorklistContext();

  const { data: providerList = [] } = useProvidersShortQuery({});
  const { data: partnerData = [] } = usePartnerShortQuery();
  const { setProviderIds, setPartnerId } = useAllWorklistStore();

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    handleFilterChange({
      ...filters,
      search: e.target.value,
    });
  };

  const handlePartnerOnChange = (e: SelectChangeEvent<string>) => {
    handleFilterChange({
      ...filters,
      partner_id: e.target.value,
    });
    handleCompletedFilterChange({
      ...completedFilters,
      partner_id: e.target.value,
    });
    setPartnerId(e.target.value);
  };

  const handleProviderOnChange = (newValues: string[]) => {
    handleFilterChange({
      ...filters,
      provider_ids: newValues,
    });
    handleCompletedFilterChange({
      ...completedFilters,
      provider_ids: newValues,
    });
    setProviderIds(newValues);
  };

  const partnerOptions =
    partnerData.map(partner => ({
      value: partner.id,
      label: partner.name,
    })) || [];

  const providerOptions =
    providerList.map(o => ({
      value: o.id,
      label: o.name,
    })) || [];

  const { data: preferences } = useWorklistTablePreferencesQuery();
  const updatePreferencesMutation = useUpdateWorklistTablePreferencesMutation();

  const handleUpdatePreferences = async (
    newPreferences: Partial<
      paths['/preferences/task-table']['patch']['requestBody']['content']['application/json']
    >,
  ) => {
    await updatePreferencesMutation.mutateAsync(newPreferences);
  };

  return {
    handleSearchChange,
    handlePartnerOnChange,
    handleProviderOnChange,
    providerOptions,
    partnerOptions,
    filters,
    appliedFiltersCount: filters.appliedFilters || 0,
    handleUpdatePreferences,
    preferences,
  };
};
